import * as numeral from 'numeral';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-devicesr7',
	styleUrls: ['./devicesr7.component.css'],
	templateUrl: './devicesr7.component.html'
})
export class Devicesr7Component implements OnInit, WidgetCore, OnDestroy {
	@Input() downloadconfig: string;
	@Input() metricsarray: any;
	@Input() sectionclass: any;
	@Input() colorsconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() nodatamessage: any;
	@ViewChild('chartElement') chartElement: ElementRef;
	public sectiontitle: string;
	public key: string;
	public groupby: string;
	public showLoad = true;
	public hasData = true;
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public downloadConfiguration: DownloadConfig;
	public legendData: any;
	public chartDataObj = [];
	public barGraphArray = [];
	public currentLegend: any;
	public currentChartData: any;
	public totalsArray = [];
	public donutOptions = {};
	public metricsArray = [];
	public downloadCSVColumns: any;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';
	public isEmail: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		this.metricsArray = _.filter(this.metricsArray, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.isEmail = this.analyticsDataModel.getCurrentPath().toLocaleLowerCase() == 'email';
		this.processLegendData();
		this.requestData();
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.nodatamessage =
			UtilityService.isUndefinedOrNull(this.nodatamessage) ||
			this.nodatamessage == 'null' ||
			this.nodatamessage == 'undefined'
				? 'No Data Available.'
				: this.nodatamessage;
	}
	processLegendData(): void {
		this.currentLegend = this.metricsArray[0].valueKey;
	}
	updateLegendData(legend: any): void {
		this.currentLegend = legend;
		this.currentChartData = this.chartDataObj[this.currentLegend];
	}

	getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}
	processResponseData(responseData: any): void {
		responseData = this.isEmail
			? responseData.reduce((acc, cur) => {
					if (cur.clicks > 0) {
						return [...acc, cur];
					} else {
						return acc;
					}
			  }, [])
			: responseData;
		for (const metric of this.metricsArray) {
			if (metric) {
				const sum = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				this.totalsArray[metric.valueKey] = sum;
			}
		}
		_.each(this.metricsArray, (metricItem) => {
			this.barGraphArray = [];
			_.each(responseData, (resp, i) => {
				const percentageDivider =
					this.totalsArray[metricItem.valueKey] === 0 ? 1 : this.totalsArray[metricItem.valueKey];
				const newObj = {
					deviceName: resp['device'],
					percentage:
						metricItem.percentageKey && metricItem.percentageKey !== ''
							? resp[metricItem.percentageKey]
							: (Number(resp[metricItem.valueKey]) / percentageDivider) * 100,
					title: this.getMetricName(metricItem.title),
					value: metricItem.isFloat
						? parseFloat(resp[metricItem.valueKey]).toFixed(2).toLocaleString() + '%'
						: Number(resp[metricItem.valueKey]).toLocaleString()
				};
				this.barGraphArray.push(newObj);
			});
			this.chartDataObj[metricItem['valueKey']] = this.barGraphArray;
		});
		this.currentChartData = this.chartDataObj[this.currentLegend];
		this.hasData = responseData.length > 0;
	}

	getMetricName(text: string): string {
		return text.replace(/_|-/g, ' ');
	}
	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}
}
